var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.$parent.IsLogged()),expression:"$parent.IsLogged()"}],staticClass:"background__custom",staticStyle:{"display":"none"},attrs:{"id":"spanBG"}})}
var staticRenderFns = []

export { render, staticRenderFns }